/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Cargos_Archived_CountInputs */

const en_cargos_archived_count = /** @type {(inputs: Cargos_Archived_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Archived ${i?.count} cargos`)
};

const es_cargos_archived_count = /** @type {(inputs: Cargos_Archived_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se archivaron ${i?.count} cargas`)
};

/**
* | output |
* | --- |
* | "Archived {count} cargos" |
*
* @param {Cargos_Archived_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_archived_count = /** @type {((inputs: Cargos_Archived_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Archived_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_archived_count(inputs)
	return es_cargos_archived_count(inputs)
});